module.exports = __webpack_public_path__ + "img/2.a4315c2b.svg";